export type ProductTypeErrorKind = 'validation' | 'unchanged' | 'session' | 'location' |
  'duplicate' | 'unauthorized' | 'unavailable' | 'network' | 'invalid-response' | 'stale';

export class ProductTypeError extends Error {
  constructor(public kind: ProductTypeErrorKind, message: string) {
    super(message);
    Object.setPrototypeOf(this, ProductTypeError.prototype);
  }
}

export function normalizeProductTypeName(value: any): string {
  const name = typeof value === 'string' ? value.trim() : '';
  if (!name) {
    throw new ProductTypeError('validation', 'El nombre es obligatorio.');
  }
  if (name.length > 200) {
    throw new ProductTypeError('validation', 'El nombre no puede exceder 200 caracteres.');
  }
  return name;
}

export function productTypeNameChanged(value: any, original: any): boolean {
  return normalizeProductTypeName(value) !== normalizeProductTypeName(original);
}



// WEBPACK FOOTER //
// ./src/utils/product-type-form.ts